/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PortfolioDto } from '../../models/portfolio-dto';

export interface PortfolioClientControllerFindAllV1$Params {
}

export function portfolioClientControllerFindAllV1(http: HttpClient, rootUrl: string, params?: PortfolioClientControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PortfolioDto>>> {
  const rb = new RequestBuilder(rootUrl, portfolioClientControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PortfolioDto>>;
    })
  );
}

portfolioClientControllerFindAllV1.PATH = '/api/v1/portfolios/client';
